<template>
    <section class="gmp-section gmp-mb-l">
        <div class="two-column-tout">
            <div class="h-c-page">

                <div class="h-c-grid">
                    <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6
            h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                        <h3 class="h-c-headline h-c-headline--one">
                            实时监控 精准管理
                        </h3>
                        <div class="h-u-mb-std two-column-tout__description">
                            <p class="">通过数据驱动的方式，员工可以根据实际需求进行补货，从而确保厨房的运营井然有序，避免过多采购或浪费，并且优化库存周转率，从而提升整体经营效率。</p>
                        </div>

                        <div>
                            <a
                                    href="https://grainservice.club:8443/GrainPrint.exe"
                                    target="_blank"
                                    class="h-c-link h-c-link--internal gmp-link"
                            >
                                下载京采配送单打印桌面程序
                            </a>

                        </div>
<!--                        <a  @click="toLevelType('/enterprise','总部管理端')"  class="h-c-link h-c-link&#45;&#45;internal gmp-link">查看餐饮业、窗口售卖、中央厨房解决方案</a>-->
<!--                        <a  @click="toLevelType('/enterprise','总部管理端')"  class="h-c-link h-c-link&#45;&#45;internal gmp-link">查看餐饮业、窗口售卖、中央厨房解决方案</a>-->
                        <a
                                href="https://grainservice.club:8443/jj.apk"
                                target="_blank"
                                class="h-c-link h-c-link--internal gmp-link"
                        >
                            下载京采称重App
                        </a>


                    </div>


                    <div class="h-c-grid__col
          h-c-grid__col-l--6  h-c-grid__col--align-middle">
                        <div class="two-column-tout__image text-center">
                            <picture>
                                <img src="@/assets/img/wxApp1.png" alt="" class="gmp-no-grab ">
                            </picture>
                        </div>
                    </div>

                </div>
            </div>


        </div>

    </section>
</template>

<script>
    export default {
        name: "TwoTout",
        methods:{
            toLevelType(data){
                this.$router.push(data)
                this.isShowDrawer = false;
                this.$('body').removeClass('h-is-showing-drawer');

            },
        }
    }
</script>

<style lang="less">


</style>